import styled from 'styled-components';
import CategoryItem from './Item';
import { mobileBreakpoint } from '../mobileBreakpoint';
import { Grid } from '@mui/material';
import sageLogo from 'src/assets/sage_logo.webp';

const Wrapper = styled.div`
  height: 100%;
  width: 30%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #f9fafb;
  border-radius: 4px 0 0 4px;
  overflow-y: auto;
  h4 {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 1.25em;
    color: ${props => props.theme.main.black};
  }
  @media ${mobileBreakpoint.mobile} {
    flex-direction: column;
    width: 100%;
    overflow: hidden;
    min-height: 8em;
    justify-content: center;
    height: 25%;
    h4 {
      font-size: 14px;
      padding-left: 1em;
    }
  }
`;

const TopSection = styled.div`
  padding: 1.25em;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  align-items: space-between;
  h4 {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 1.25em;
    color: ${props => props.theme.main.black};
  }
  @media ${mobileBreakpoint.mobile} {
    flex-direction: column;
    display: flex;
    padding: 0 1em;
    align-items: flex-start;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      /* WebKit */
      width: 0;
      height: 0;
    }
    h4 {
      margin: 0;
      font-size: 14px;
    }
  }
`;

const Header = styled.div`
  text-align: center;
  img {
    width: 100%;
    max-height: 160px;
  }
  @media ${mobileBreakpoint.mobile} {
    display: grid;
    grid-template-columns: 2fr 1fr;
    img {
      object-fit: contain;
      max-height: 4em;
      width: auto;
    }
  }
`;

const BottomSection = styled.div`
  display: flex;
  .tree__logo {
    width: 40%;
    min-height: 3em;
  }
  @media ${mobileBreakpoint.mobile} {
    display: none;
  }
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media ${mobileBreakpoint.mobile} {
    flex-direction: row;
    width: 100%;
    overflow-x: scroll;
    box-sizing: content-box;
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none;
    &::-webkit-scrollbar {
      /* WebKit */
      width: 0;
      height: 0;
    }
  }
`;
const HeaderWrapper = styled.div`
  margin-bottom: 5px;
  @media ${mobileBreakpoint.mobile} {
    display: flex;
    justify-content: flex-start;
  }
`;

const FirmLogo = styled('div')`
  img {
    width: 60%;
    max-height: 150px;
    margin-bottom: 1em;
    margin-left: 2.5em;
  }
`;

const ITEMS = [
  { label: 'Your Details', category: 'profile' },
  { label: 'Your Personality', category: 'tifin-personality' },
  { label: 'Your Risk', category: 'tifin-risk' },
  { label: 'Plan your future', category: 'tifin-plan' },
];

type Props = {
  questions: any[];
  questionnaireValue: any;
  metadata: any;
};

function Sidebar({ questions, questionnaireValue, metadata }: Props) {
  const uniqueSources =
    questions && questions.length > 0
      ? questions
        .map(({ source }) => source)
        .filter((question, index, self) => self.indexOf(question) === index)
      : [];
  const getProgress = (category: string) => {
    const categoryQuestions =
      questions && questions.length > 0
        ? questions.filter(({ source }) => source === category)
        : [];
    const questionIds = categoryQuestions.map(({ questionId }) => questionId);
    const completedQuestions = questionnaireValue
      ? Object.keys(questionnaireValue)
      : [];
    const completionRatio =
      completedQuestions.reduce(
        (a, b) => (questionIds.includes(b) ? (a += 1) : a),
        0,
      ) / questionIds.length;
    return completionRatio * 100;
  };

  return (
    <Wrapper>
      <TopSection>
        <Grid>
          <FirmLogo>
            <img className="logo" src={sageLogo} alt="sage-logo" />
          </FirmLogo>

          <ItemsWrapper>
            {ITEMS.filter(item => uniqueSources.includes(item.category)).map(
              (item, index) => (
                <CategoryItem
                  progress={getProgress(item.category) * 1}
                  key={index.toString()}
                  item={item}
                />
              ),
            )}
          </ItemsWrapper>
        </Grid>
        <HeaderWrapper>
          <Header>
            {metadata?.advisorDetails?.firmLogo && (
              <img
                src={metadata?.advisorDetails?.firmLogo}
                alt={metadata?.firmName ?? 'Logo'}
              />
            )}
          </Header>
        </HeaderWrapper>
      </TopSection>
    </Wrapper>
  );
}

export default Sidebar;
